import { useMutation } from '@tanstack/react-query';

import { useInvalidateChannelsList } from '@/entities/channel';
import { ApiError } from '@/shared/api/ApiError';
import {
  connectMaxPersonal,
  type MaxPersonalConnectResponse,
} from '@/shared/api/channels/maxPersonal';
import { useNotifications } from '@/shared/ui/Notifications';

export function useMaxPersonalConnect() {
  const invalidateChannelsList = useInvalidateChannelsList();
  const { addNotification } = useNotifications();

  const mutation = useMutation<
    MaxPersonalConnectResponse,
    ApiError,
    { channelId: string; name?: string }
  >({
    mutationFn: ({ channelId, name }) => connectMaxPersonal(channelId, name),
    onSuccess: () => {
      void invalidateChannelsList();
    },
    onError: (error) => {
      addNotification({
        title: error.message,
        caption: error?.data?.details,
      });
    },
  });

  return {
    connect: (channelId: string, name?: string) =>
      mutation.mutateAsync({ channelId, name }),
    isPending: mutation.isPending,
    data: mutation.data,
    error: mutation.error,
    reset: mutation.reset,
  };
}
